import { render, staticRenderFns } from "./EditCompanyDialog.vue?vue&type=template&id=7798ac70"
import script from "./EditCompanyDialog.vue?vue&type=script&lang=ts"
export * from "./EditCompanyDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports